"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _urlUtils = require("../../common/utils/domain/otherPackage/url-utils");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const _require = require('@tencent/cms-design-component'),
  Whitepaper = _require.Whitepaper;
const formatWhitepaper = (properties, {
  domains
}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains
    }),
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const modTitle = properties.modTitle,
    color = properties.color,
    _properties$whitepape = properties.whitepaperList,
    whitepaperList = _properties$whitepape === void 0 ? [] : _properties$whitepape;
  const configuration = whitepaperList.map((whitepaperItem, index) => {
    const _whitepaperItem$title = whitepaperItem.title,
      title = _whitepaperItem$title === void 0 ? '' : _whitepaperItem$title,
      _whitepaperItem$descr = whitepaperItem.description,
      description = _whitepaperItem$descr === void 0 ? '' : _whitepaperItem$descr,
      _whitepaperItem$thumb = whitepaperItem.thumbnail,
      thumbnail = _whitepaperItem$thumb === void 0 ? '' : _whitepaperItem$thumb,
      _whitepaperItem$href = whitepaperItem.href,
      hrefBase = _whitepaperItem$href === void 0 ? '' : _whitepaperItem$href;
    const formatContent = formatUrlInText(description, {
      reportEvent: 'click_whitePaper_richtext_href'
    });
    const href = (0, _urlUtils.formatUrlString)(hrefBase);
    return {
      title,
      description: formatContent,
      thumbnail,
      href,
      extendProps: {
        'report-event': 'click_whitePaper_href',
        'report-ext1': index,
        'report-ext2': title,
        'report-ext3': href
      }
    };
  });
  return {
    modTitle,
    configuration,
    bgColor: color
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatWhitepaper = formatWhitepaper(data, {
        domains
      }),
      modTitle = _formatWhitepaper.modTitle,
      configuration = _formatWhitepaper.configuration,
      bgColor = _formatWhitepaper.bgColor;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色

    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_whitepaper', componentKey, modTitle]), {
      style: bgStyle
    }), /*#__PURE__*/React.createElement(Whitepaper, {
      flexTitle: modTitle,
      configuration: configuration
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}